exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Glyph{fill:currentColor;width:1em;height:1em;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"minimize":true}!./~/stylus-loader!./src/app/components/Glyph/Glyph.styl
// module id = 604
// module chunks = 0